<template>
  <div>
    <v-dialog
      v-model="dialog.contactForm"
      max-width="800px"
    >
      <base-contact-form
        title="наш специалист свяжется с вами"
        subtitle="Заполните форму"
        @close="dialog.contactForm = false"
      />
    </v-dialog>
    <v-dialog
      v-model="dialog.tourism"
      max-width="90%"
    >
      <base-tourism
        :title="selected.title"
        :location="selected.location"
        :description="selected.description"
        :images="selected.images"
        :site_url="selected.site_url"
        @close="dialog.tourism = false"
      />
    </v-dialog>
    <v-container>
      <v-app-bar
        id="home-app-bar"
        app
        style="position: relative;"
        color="white"
        elevation="0"
        height="60"
      >
        <base-img
          :src="require('@/assets/logo.svg')"
          class="mr-3"
          contain
          max-width="200"
          width="100%"
        />
        <v-spacer />
        <div>
          <v-tabs
            class="hidden-sm-and-down"
            optional
          >
            <v-tab
              :ripple="false"
              active-class="text--primary"
              class="font-weight-bold"
              min-width="96"
              text
              @click="$vuetify.goTo('#features', options)"
            >Преимущества</v-tab>
            <v-tab
              :ripple="false"
              active-class="text--primary"
              class="font-weight-bold"
              min-width="96"
              text
              @click="$vuetify.goTo('#buildings', options)"
            >Наши здания</v-tab>
            <v-tab
              :ripple="false"
              active-class="text--primary"
              class="font-weight-bold"
              min-width="96"
              text
              @click="$vuetify.goTo('#gallery', options)"
            >Галерея</v-tab>
            <v-tab
                :ripple="false"
                active-class="text--primary"
                class="font-weight-bold"
                min-width="96"
                text
            >
              <v-menu offset-y open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Отдых и туризм
                  </span>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in dropdown_objects"
                    :key="index"
                    @click="open(item.id)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-tab>
            <v-tab
              :ripple="false"
              active-class="text--primary"
              class="font-weight-bold"
              min-width="96"
              text
            >
              <v-btn
                color="primary"
                class="hidden-xs-only"
                large
                @click="dialog.contactForm = true"
              >
                <v-icon class="mr-2">call</v-icon>
                Позвоните мне
              </v-btn>
            </v-tab>
          </v-tabs>
        </div>
        <v-app-bar-nav-icon
          class="hidden-md-and-up"
          @click="drawer = !drawer"
        />
      </v-app-bar>

      <home-drawer
        v-model="drawer"
        :items="itemMenu"
        :dropdown="dropdown_objects"
        @clikedMenuItem="open"
      />
    </v-container>
  </div>
</template>

<script>
  import BaseContactForm from '../../components/base/ContactForm'
  import BaseTourism from '../../components/base/Tourism'
  export default {
    name: 'HomeAppBar',

    components: {
      BaseContactForm,
      BaseTourism,
      HomeDrawer: () => import('./Drawer'),
    },

    data: () => ({
      drawer: null,
      dialog: {
        contactForm: false,
        tourism: false
      },
      selected: {
        title: null,
        location: null,
        description: null,
        images: [],
        site_url: null
      },
      dropdown_objects: [
        {
          id: 1,
          title: 'Гостиница "Фараб"',
          location: 'Республика Казахстан, Туркестанская область, Отырарский район, село Когам',
          description: 'Отель «Фараб» приглашает паломников, которые знакомятся с руинами древнего города Отрар и посещают сакральные места Туркестанской области – мавзолей Арыстан баб и другие святыни.  \n' +
          '\n\nОтрар — сокровищница культуры тюрков, один из древнейших городов Средней Азии на Великом Шелковом пути. Он хранит множество тайн и всегда привлекает туристов, здесь не прекращаются археологические раскопки. Комфортный отель — важная   часть туристической  инфраструктуры, предлагает гостям уютные номера и необходимый сопутствующий сервис.',
          images: [
            'https://ibc.kz/tourism/farab/image_1.jpeg',
            'https://ibc.kz/tourism/farab/image_2.jpeg',
            'https://ibc.kz/tourism/farab/image_3.jpeg',
            'https://ibc.kz/tourism/farab/image_4.jpeg'
          ],
          site_url: null
        },
        {
          id: 2,
          title: 'Санаторно-оздоровительный комплекс "ZEREN"',
          location: 'Республика Казахстан, Акмолинская область, Зерендинский район, село Зеренда, улица Зона отдыха',
          description: 'Санаторно-оздоровительный комплекс «Zeren» —  ваш лучший отдых в экологически чистом месте. Зона отдыха находится посреди лесопарковой зоны на берегу озера Зеренды, и даже воздух тут целебен. Кроме того, отдыхающим предлагается современный комплекс оздоравливающих процедур, все виды активного отдыха для любого времени года. Вы обязательно захотите вернуться сюда снова и снова.',
          images: [
            'https://ibc.kz/tourism/zeren/image_1.jpeg',
            'https://ibc.kz/tourism/zeren/image_2.jpeg',
            'https://ibc.kz/tourism/zeren/image_3.jpeg',
            'https://ibc.kz/tourism/zeren/image_4.jpeg'
          ],
          site_url: 'https://zeren.kz/'
        },
        {
          id: 3,
          title: 'Акбулак-Алтай',
          location: 'Республика Казахстан, Восточно-Казахстанская оласть, Катон-Карагайский район, 5-6 км от села Акмарал',
          description: 'Отдых, полный релакс, оздоровительные процедуры и омолаживающее пантолечение – все это можно получить в зоне отдыха «Акбулак-Алтай». Зона отдыха расположена в горном ущелье на берегу реки Тихая в Катон-Карагайском районе ВКО. Кумыс, мед и продукты пчеловодства, фитотерапия, полный комплекс физиотерапевтических процедур и, конечно, пантолечение, которое способно творить чудеса, — все это вернет вам здоровье и подарит заряд бодрости на целый год.',
          images: [
            'https://ibc.kz/tourism/akbulak/image_1.jpeg',
            'https://ibc.kz/tourism/akbulak/image_2.jpeg',
            'https://ibc.kz/tourism/akbulak/image_3.jpeg',
            'https://ibc.kz/tourism/akbulak/image_4.jpeg',
            'https://ibc.kz/tourism/akbulak/image_5.jpeg'
          ],
          site_url: null
        }
      ],
      items: [
        '+7 (702) 947-76-34',
        '+7 (702) 947-76-34',
        '+7 (702) 947-76-34',
      ],
      itemMenu: [
        // {
        //   id_building: 1,
        //   location: 'Кабанбай б. 17 н.п.15 (блок А)',
        //   mobile: '+7 (702) 947-76-34',
        // },
        // {
        //   id_building: 2,
        //   location: 'Кабанбай б. 17 н.п.14 (блок Е)',
        //   mobile: '+7 (702) 947-76-34',
        // },
        // {
        //   id_building: 3,
        //   location: 'Кабанбай б. 19 (блок A,B, С, Е)',
        //   mobile: '+7 (702) 947-76-34',
        // },
        {
          link: '#features',
          title: 'Преимущества',
        },
        {
          link: '#buildings',
          title: 'Наши здания',
        },
        {
          link: '#gallery',
          title: 'Галерея',
        },
      ],
    }),
    methods: {
      open (id) {
        this.selected.title = this.dropdown_objects.find(el => el.id === id).title
        this.selected.location = this.dropdown_objects.find(el => el.id === id).location
        this.selected.description = this.dropdown_objects.find(el => el.id === id).description
        this.selected.images = this.dropdown_objects.find(el => el.id === id).images
        this.selected.site_url = this.dropdown_objects.find(el => el.id === id).site_url
        this.dialog.tourism = true
      }
    },
    computed: {
      options () {
        return {
          duration: 679,
          offset: 0,
          easing: 'easeOutQuint',
        }
      },
      element () {
        return this.$refs.button
      },
    },
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
